import {
  BaseEntityDTO,
  EntryDTO,
  IBaseEntityDTO,
  IEntryDTO,
  ISubmissionDTO,
  ISubmissionEntryFormFieldDTO,
  SubmissionDTO,
  SubmissionEntryFormFieldDTO,
} from './';

export interface ISubmissionEntryFormDTO extends IBaseEntityDTO {
  entry: IEntryDTO;
  submission: ISubmissionDTO;
  fields: ISubmissionEntryFormFieldDTO[];
  submitted: boolean;
  submitted_date?: Date;
  isValid(): boolean;
}

export class SubmissionEntryFormDTO extends BaseEntityDTO implements ISubmissionEntryFormDTO {
  entry: IEntryDTO;
  submission: ISubmissionDTO;
  fields: ISubmissionEntryFormFieldDTO[];
  submitted: boolean;
  submitted_date?: Date;

  constructor(data?: Partial<SubmissionEntryFormDTO>) {
    super(data);
    this.entry = new EntryDTO(data?.entry);
    this.submission = new SubmissionDTO(data?.submission);
    this.fields = data?.fields
      ? data.fields.map((field) => new SubmissionEntryFormFieldDTO(field))
      : [];
    this.submitted = data?.submitted || false;
  }
  isValid = (): boolean => {
    let valid = true;
    for (const field of this.fields) {
      if (field.isValid() == false) {
        valid = false;
        break;
      }
    }
    return valid;
  };
}
